import { Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';

export interface TaskBankFilterState {
  serviceCodeKey: string | null;
  eventKey: string | null;
  tabLabel: string;
}

const DEFAULT_TASK_BANK_FILTER_STATE: TaskBankFilterState = {
  serviceCodeKey: null,
  eventKey: null,
  tabLabel: '',
};

@Injectable({
  providedIn: 'root',
})
export class TaskBankFilterStateService {
  private readonly taskBankFilterStateSignal = signal<TaskBankFilterState>(
    DEFAULT_TASK_BANK_FILTER_STATE
  );

  readonly taskBankFilterState = this.taskBankFilterStateSignal.asReadonly();
  readonly taskBankFilterState$ = toObservable(this.taskBankFilterState);

  updateFilterState(state: Partial<TaskBankFilterState>): void {
    this.taskBankFilterStateSignal.update((currentState) => ({
      ...currentState,
      ...state,
    }));
  }

  clearFilterState(tabLabel = ''): void {
    this.taskBankFilterStateSignal.set({
      ...DEFAULT_TASK_BANK_FILTER_STATE,
      tabLabel,
    });
  }
}
